import { render, staticRenderFns } from "./ApprHeader.vue?vue&type=template&id=58c6f79e&scoped=true"
import script from "./ApprHeader.vue?vue&type=script&lang=js"
export * from "./ApprHeader.vue?vue&type=script&lang=js"
import style0 from "./ApprHeader.vue?vue&type=style&index=0&id=58c6f79e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c6f79e",
  null
  
)

export default component.exports